import { render, staticRenderFns } from "./UserProPrompt.vue?vue&type=template&id=df7a8bae&scoped=true"
import script from "./UserProPrompt.vue?vue&type=script&lang=js"
export * from "./UserProPrompt.vue?vue&type=script&lang=js"
import style0 from "./UserProPrompt.vue?vue&type=style&index=0&id=df7a8bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7a8bae",
  null
  
)

export default component.exports